export default "__VITE_ASSET__71126a2e__"